import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideService() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            後援願い
          </Typography>
          　デーリー東北新聞社にスポーツ、芸術、文化等の催し物の名義後援を希望される場合は、下記をご覧いただき、必要事項を記入の上、提出してください。<br />
          　なお、承諾は以下の場合とさせていただきます。<br />
          <ul className="my-3">
            <li>地域住民及び読者の福祉、文化などの向上に寄与するもの</li>
            <li>公序良俗・法律に反しないこと</li>
            <li>公益性があること</li>
            <li>その他、弊社が適当と判断した事業であること</li>
          </ul>
          　後援を希望する方は、下記の申請書をダウンロードしていただき、必要事項を記入してください。<br/>
          　申請には、下記の書類が必要です。<br/>
          <ul>
            <li>所定の申請書（下記よりダウンロード、もしくはデーリー東北本社にあります）</li>
            <li>イベント詳細資料（企画書など）</li>
          </ul>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/pdf/kouen__20230620.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  後援申請書
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
          　後援承諾書は、１週間以内に、連絡先のＦＡＸ番号へお届けします。<br/>
          　なお、後援承諾書原本が必要な場合は、84円切手を貼付した返信用封筒を申請書と一緒に提出してください。<br/>
          　イベントの入場料金が1,000円を超える場合は、予算書の添付をお願いします。<br/>
          <br/>
          　ポスター・チラシなどに名義を記載した場合は、下記担当部署までお送りください。<br/>
          　また、イベントが終了したら、実施報告書のご提出をお願いいたします。（定型はありません）<br/>
        </Box>

      </div>
    </div>
  );
}

export default GuideService;
